import React from 'react';

import { Placeholder } from './placeholder';

export const Paragraph = ({
  children,
  size = 'small',
  ...other
}: {
  size?: 'large' | 'small' | 'default';
  children: React.ReactNode;
}) => (
  <div className="Placeholder Value">
    <Placeholder size={size} loading={true} {...other}>
      {children}
    </Placeholder>
  </div>
);
